import React from "react"
import { IScheduleTemplate, ISchedulePatternTemplate } from "../../../../models"
import ScheduleTemplateInfoDetail from "./ScheduleTemplateInfoDetail"
import ScheduleTemplateTimeInfoDetail from "./ScheduleTemplateTimeInfoDetail"
import { grey500 } from "material-ui/styles/colors"
interface IProps {
  scheduelTemplate: IScheduleTemplate
  handleAddPatternTemplates(scheduleTemplate: IScheduleTemplate, newPatternTemplates: ISchedulePatternTemplate[], days: number[]): void
  handleDeletePatternTemplates(scheduleTemplate: IScheduleTemplate, selectedPatternTemplates: ISchedulePatternTemplate[]): void
  handleUpdatePatternTemplateQty(scheduleTemplate: IScheduleTemplate, newPatternTemplate: ISchedulePatternTemplate, quantity: number): void
  handleClonePatternTemplates(scheduleTemplate: IScheduleTemplate, clonePatternTemplates: ISchedulePatternTemplate[]): void
  handleUpdateUniquePatternTemplate(scheduleTemplate: IScheduleTemplate, uniquePatternTemplate: ISchedulePatternTemplate): void
}

const ScheduleTemplateDetailExpander: React.SFC<IProps> = (props: IProps) => {
  return (
    <div style={{ borderTop: "1px solid", borderColor: grey500 }}>
      <ScheduleTemplateInfoDetail
        scheduleTemplate={props.scheduelTemplate}
      />
      <div style={{ borderTop: "1px solid", borderColor: grey500 }} />
      <ScheduleTemplateTimeInfoDetail
        scheduleTemplate={props.scheduelTemplate}
        handleAddPatternTemplates={props.handleAddPatternTemplates}
        handleDeletePatternTemplates={props.handleDeletePatternTemplates}
        handleUpdatePatternTemplateQty={props.handleUpdatePatternTemplateQty}
        handleClonePatternTemplates={props.handleClonePatternTemplates}
        handleUpdateUniquePatternTemplate={props.handleUpdateUniquePatternTemplate}
      />
    </div>
  )
}

export default ScheduleTemplateDetailExpander